import React from 'react';
import {Redirect} from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import {AuthContext} from './context';
import axios from 'axios';
import '../globales';
import GLOBAL from "../globales";
import {Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
    }, image: {
        backgroundImage: 'url(https://uads.unap.cl/conadi/archivos/imagenes/imgBienvenidaV_C.JPG)',
        backgroundRepeat: 'no-repeat',
        backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
    }, paper: {
        margin: theme.spacing(8, 4), display: 'flex', flexDirection: 'column', alignItems: 'center',
    }, avatar: {
        margin: theme.spacing(1), backgroundColor: theme.palette.secondary.main,
    }, form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    }, submit: {
        margin: theme.spacing(3, 0, 2),
    }, large: {
        width: theme.spacing(30), height: theme.spacing(30), borderRadius: 0
    }, logo: {
        width: theme.spacing(15), height: theme.spacing(15), borderRadius: 0
    }
}));

export default function Login() {
    const classes = useStyles();

    const [data, setData] = React.useState({
        username: '', password: '', userData: {
            token: ''
        }
    });
    const [dialog, setDialog] = React.useState({
        open: false, text: ''
    });

    const handleDialogOpen = text => setDialog({open: true, text: text});
    const handleDialogClose = () => setDialog({...dialog, open: false});

    const handleInputChange = (val) => {
        setData({
            ...data, username: val
        });
    }

    const handlePasswordChange = (val) => {
        setData({
            ...data, password: val
        });
    }

    const {signIn} = React.useContext(AuthContext);

    const loginHandle = (username, password) => {
        if (username.length === 0 || password.length === 0) {
            handleDialogOpen('Datos incompletos. Debe ingresar su email y contraseña');
            return;
        }

        axios.post(GLOBAL.URL_LOGIN, {
            operacion: 'login', usuario: username, pass: password
        })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.token !== '') {
                        signIn(response.data);
                    } else {
                        handleDialogOpen(`Error: ${response.data.message}`);
                    }
                } else {
                    handleDialogOpen('Error: No se pudo iniciar sesión.');
                }
            })
            .catch(function (error) {
                handleDialogOpen(`Error: Hubo un problema al conectarse con el servicio en línea. ${error}`);
            });
    }

    if (localStorage.getItem("userToken") !== null) {
        // return <Redirect to={GLOBAL.ROOT_REF + "home"}/>;
        return <Redirect to={"/home"}/>;
    }

    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline/>
            <Grid item xs={false} sm={4} md={7} className={classes.image}/>
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <Avatar src="https://uads.unap.cl/conadi/archivos/imagenes/logo_app_v3.png"
                            className={classes.large}/>
                    <Typography component="h1" variant="h5">
                        Culturas Andinas
                    </Typography>
                    <Typography>
                        Aplicación para el aprendizaje de cultura y lengua Aymara, Quechua y Diaguita
                    </Typography>
                    <form className={classes.form} noValidate>
                        <TextField variant="outlined" margin="normal" required fullWidth id="email" label="Email"
                                   name="email" autoComplete="email" autoFocus
                                   onChange={val => handleInputChange(val.target.value)}/>
                        <TextField variant="outlined" margin="normal" required fullWidth name="password"
                                   label="Contraseña"
                                   type="password" id="password" autoComplete="current-password"
                                   onChange={val => handlePasswordChange(val.target.value)}
                        />
                        {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
                        <Button
                            type='button'
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            // href="/home"
                            onClick={() => {
                                loginHandle(data.username, data.password)
                            }}
                        >
                            Iniciar Sesión
                        </Button>
                        <Grid container>
                            <Grid item xs>
                                <Link href={GLOBAL.ROOT_REF + "recuperar"} variant="body2">
                                    ¿Olvidaste tu contraseña?
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link href={GLOBAL.ROOT_REF + "registrar"} variant="body2">
                                    {"Registrarse"}
                                </Link>
                            </Grid>
                        </Grid>
                        <Grid container justifyContent={"center"} spacing={4} alignItems={"center"}>
                            <Grid item>
                                <Avatar src={process.env.PUBLIC_URL + "/img/conadi.png"} className={classes.logo}/>
                            </Grid>
                            <Grid item>
                                <Avatar src={process.env.PUBLIC_URL + "/img/UNAP.png"} className={classes.logo}/>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
            <Dialog open={dialog.open} onClose={handleDialogClose}>
                <DialogContent>
                    <Grid container={true}>
                        <Grid item={true} xs={2} alignContent={'center'}>
                            <WarningIcon fontSize={"large"} color={'error'}/>
                        </Grid>
                        <Grid item={true} xs={10}>
                            <DialogContentText color={'error'}>
                                {dialog.text}
                            </DialogContentText>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}